import React, { Component } from "react";
import PropTypes from "prop-types";
import reactCSS from "reactcss";
import ReactFitText from "react-fittext";

class CardTitle extends Component {
  static propTypes = {
    fit: PropTypes.bool,
    compressor: PropTypes.number,
    maxFontSize: PropTypes.number,
    children: PropTypes.any
  };

  static defaultProps = {
    compressor: 1.4,
    maxFontSize: 40
  };

  getElement(styles) {
    if (this.props.fit) {
      return (
        <ReactFitText
          maxFontSize={this.props.maxFontSize}
          compressor={this.props.compressor}
        >
          <h2 style={styles.title}>{this.props.children}</h2>
        </ReactFitText>
      );
    } else {
      return <h2 style={styles.title}>{this.props.children}</h2>;
    }
  }

  render() {
    const styles = reactCSS(
      {
        default: {
          title: {
            margin: 0,
            display: "block",
            padding: "0px",
            color: "#000",
            fontWeight: "500",
            fontFamily: "Roboto",
            fontSize: "26px",
            wordBreak: "break-word"
          },
          paragraph: {
            margin: "0px"
          }
        },
        secondary: {
          title: {
            padding: "0 12px 12px",
            fontSize: "23px",
            fontWeight: "300"
          },
          paragraph: {
            margin: "0px"
          }
        }
      },
      this.props,
      this.state
    );

    return (
      <div className="card-title" style={styles.container}>
        {this.getElement(styles)}
      </div>
    );
  }
}

export default CardTitle;



// WEBPACK FOOTER //
// ./src/components/support/card/card-title.js